import { combineReducers, AnyAction } from 'redux';
import {
 GET_ALL_EVALUATIONS,
 GET_MESSAGE_THREADS,
 GET_UNREAD_MESSAGES_COUNT,
 GOT_ALL_EVALUATIONS,
 GOT_MESSAGE_THREADS,
 GOT_UNREAD_MESSAGES_COUNT,
 LOADED_ITEM,
 LOADED_ITEMS,
 LOADING_ITEM,
 LOADING_ITEMS,
 UPDATED_ASSESSMENT_EXPERIENCE,
 UPDATED_INDUSTRY_APPROVAL,
 UPDATED_TEACHING_APPROVAL,
 UPDATE_APPLICATION_STATUS,
 UPDATE_ASSESSMENT_APPROVAL,
 UPDATE_INDUSTRY_APPROVAL,
 UPDATE_TEACHING_APPROVAL,
 UPDATING_ITEM,
} from './actions';
import { EvaluationState, ItemState, ItemsState, MessageThreadState, ThreadState } from './state';
import { noCrudResult } from './types';
import { PagedResponseEmpty } from '@ofqual/portal-core/core/types';
import { Evaluation } from '../domain/ApprovalSubject';

const itemInitialState: ItemState = {
 status: 'NOT_LOADED',
 item: null,
 lastCrudResult: noCrudResult(),
};

const item = (
 state: ItemState = itemInitialState,
 action: AnyAction,
): ItemState => {
 const { type, payload } = action;
 switch (type) {
  case LOADING_ITEM:
   return {
    ...state,
    item: null,
    status: 'LOADING',
    lastCrudResult: noCrudResult(),
   };
   case UPDATING_ITEM:
      return {
        ...state,
        item: null,
        status: "UPDATING",
        lastCrudResult: noCrudResult(),
      };
  case UPDATE_APPLICATION_STATUS:
      return {
        ...state,
        item: null,
        status: "UPDATING",
        lastCrudResult: noCrudResult(),
      };
  case LOADED_ITEM:
   return {
    ...state,
    status: 'LOADED',
    item: payload,
   };
  default:
   return state;
 }
};

const itemsInitialState: ItemsState = {
 status: 'NOT_LOADED',
 response: PagedResponseEmpty,
 hasData: false,
};

const items = (
 state: ItemsState = itemsInitialState,
 action: AnyAction,
): ItemsState => {
 const { type, payload } = action;
 if (type === LOADING_ITEMS) {
  return {
   ...state,
   status: 'LOADING',
  };
 }
 if (type === LOADED_ITEMS) {
  return {
   ...state,
   status: 'LOADED',
   response: payload,
   hasData: true,
  };
 }
 return state;
};

const threadState: ThreadState = {
 status: 'NOT_LOADED',
 hasData: false,
 messagesUnread: 0,
};

const threads = (
 state: ThreadState = threadState,
 action: AnyAction,
): ThreadState => {
 const { type, payload } = action;
 if (type === GET_UNREAD_MESSAGES_COUNT) {
  return {
   ...state,
   status: 'LOADING',
  };
 }
 if (type === GOT_UNREAD_MESSAGES_COUNT) {
  return {
   ...state,
   status: 'LOADED',
   messagesUnread: payload,
   hasData: true,
  };
 }
 return state;
};

const evaluationState: EvaluationState = {
 status: 'NOT_LOADED',
 evaluation: {} as Evaluation,
};

const evaluation = (
 state: EvaluationState = evaluationState,
 action: AnyAction,
): EvaluationState => {
 const { type, payload } = action;
 if (
  type === GET_ALL_EVALUATIONS ||
  type === UPDATE_ASSESSMENT_APPROVAL ||
  type === UPDATE_INDUSTRY_APPROVAL ||
  type === UPDATE_TEACHING_APPROVAL
 ) {
  return {
   ...state,
   status: 'LOADING',
  };
 }
 if (
  type === GOT_ALL_EVALUATIONS ||
  type === UPDATED_ASSESSMENT_EXPERIENCE ||
  type === UPDATED_INDUSTRY_APPROVAL ||
  type === UPDATED_TEACHING_APPROVAL
 ) {
  return {
   ...state,
   status: 'LOADED',
   evaluation: payload,
  };
 }
 return state;
};

const messageThreadState: MessageThreadState = {
  status: "NOT_LOADED",
  hasData: false,
  messageThreads: [] ,
};

const messageThreads = (
  state: MessageThreadState = messageThreadState,
  action: AnyAction
): MessageThreadState => {
  const { type, payload } = action;
  if (type === GET_MESSAGE_THREADS) {
    return {
      ...state,
      status: "LOADING",
      hasData:false
    };
  }
  if (type === GOT_MESSAGE_THREADS) {
    return {
      ...state,
      status: "LOADED",
      messageThreads: payload,
      hasData: true,
    };
  }
  return state;
};


export const rootReducer = combineReducers({
 item,
 items,
 threads,
 evaluation,
 messageThreads
});
